import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import './EndorsementBadge.scss';
import { ENDORSEMENT_TYPE_PLUMBER, ENDORSEMENT_TYPE_DRAINLAYER } from 'pgdb-data-layer/lib/Helpers/Endorsement';
import { NavLink } from 'react-router-dom';

const EndorsementBadge = ({ endorsements, futureEndorsements, applicationEndorsements, onViewLicence }) => {
   if ((!endorsements || endorsements.length === 0) && (!futureEndorsements || futureEndorsements.length === 0)) {
      return null;
   }

   const sortByType = (list) => [...list].sort((a, b) => a.endorsementTypeCode.localeCompare(b.endorsementTypeCode));

   const renderBadge = (endorsement) => {
      const link = process.env.REACT_APP_ENDORSEMENT_REGISTER_URL;

      const expiryDate = endorsement.expiryDate
         ? Moment(endorsement.expiryDate).format('DD/MM/YYYY')
         : '-';
      const year = endorsement.startDate
         ? Moment(endorsement.startDate).format('YYYY')
         : '';
      const isInactive = endorsement.endorsementStatusCode === 'INCT';
      const isActive = endorsement.endorsementStatusCode === 'ACTV';
      const disciplineColor = isActive ? 'white' : 'black';   
      const status = isActive ? 'Self-certifying endorsement' : endorsement.endorsementStatusDescription;
      const discipline = endorsement.disciplineCode.trim() === "D" ? 'Drainlayer' : 'Plumber';
      const iconPath = `/images/icon-${discipline.toLowerCase()}-${disciplineColor}.svg`;
      return (
         <div key={endorsement.endorsementId} className="endorsement-badge-container">
            <div className={`endorsement-licence-card ${discipline.toLowerCase()}`}>
               <div className={`endorsement-card-top ${endorsement.endorsementStatusDescription.toLowerCase()}`}>
                  <img
                     className="endorsement-card-image"
                     src={iconPath}
                     alt={`${discipline} icon`}
                  />
                  <p className="endorsement-level">Certifying</p>
                  <p className="endorsement-discipline">{discipline}</p>
               </div>
               <div className={`endorsement-card-bottom bottom-${endorsement.endorsementStatusDescription.toLowerCase()}`}>
                  <span className="endorsement-status">{status}</span>
                  <div className="endorsement-cert-logo">
                     <img src="/images/icon-self-certification.png" alt="Self Certification" />
                  </div>
                     <div className="endorsement-status-info">
                     { isActive && (
                        <div className="endorsement-expiry-row"><span className="endorsement-expired">Expires: {expiryDate}</span> </div>
                     )}
                     </div>
               </div>
            </div>
            {isActive && (
               <div className="badge-view-link">
                  <a
                     href="#"
                     className="view-link"
                     onClick={e => { e.preventDefault(); onViewLicence && onViewLicence(); }}
                  >View Endorsement</a>
               </div>
            )}
            <div className="badge-view-link">
               <a href={link} className="view-link" target="_blank" rel="noopener noreferrer">Visit Register</a>
            </div>
            { endorsement.canApplyForRenewal && (!applicationEndorsements || applicationEndorsements.length === 0) && (
               <div className="badge-view-link">
                  <NavLink to="/renew-endorsement" className="view-link">ℹ️Apply for renewal</NavLink>
               </div>
            )}
            { isInactive && (
               <div className="badge-view-link">
                  <NavLink to="/licences" className="view-link">View Licence</NavLink>
               </div>
            )}
         </div> 
      );
   };

   return (
      <div className="endorsement-badges-section">
         <div className="row">
            <div className="col s12 m10 l10 offset-l1">
               <div className="endorsement-columns">
                  {endorsements && endorsements.length > 0 && (
                     <div className="endorsement-column">
                        <h6 className="subheader">Current Endorsements</h6>
                        <div className="badges-grid">
                           {sortByType(endorsements).map((endorsement) => renderBadge(endorsement))}
                        </div>
                     </div>
                  )}
                  {futureEndorsements && futureEndorsements.length > 0 && (
                     <div className="endorsement-column">
                        <h6 className="subheader">Future Endorsements</h6>
                        <div className="badges-grid">
                           {sortByType(futureEndorsements).map((endorsement) => renderBadge(endorsement))}
                        </div>
                     </div>
                  )}
               </div>
            </div>
         </div>
      </div>
   );
};

EndorsementBadge.propTypes = {
   endorsements: PropTypes.array,
   futureEndorsements: PropTypes.array,
   applicationEndorsements: PropTypes.array,
   onViewLicence: PropTypes.func,
};

EndorsementBadge.defaultProps = {
   endorsements: [],
   futureEndorsements: [],
};

export default EndorsementBadge;
